// components/FadeSection.jsx
import React from "react";
import FadeItem from "./fadeItem";

const FadeSection = ({ texts, style }) => {
  return texts.map((text, index) => {
    const isBullet = text.startsWith("•") || text.startsWith("○");
    const isQuestion = text.startsWith("¿");
    const isBulletCircle = text.startsWith("○");

    return (
      <FadeItem
        key={index}
        text={text}
        style={{
          ...style,
          fontWeight: isQuestion ? 700 : style?.fontWeight || 400,
          textAlign: isQuestion ? "left" : "justify",
          alignSelf: isQuestion ? "flex-start" : "stretch",
          marginLeft: isBullet ? (isBulletCircle ? "2em" : "1em") : 0,
        }}
      />
    );
  });
  
};

export default FadeSection;

